import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';
import { RAITING_NUMBERS } from '@/constants';
import { Pregunta, SurveyStepsHandler } from '@/hooks/useSurvey';

interface Raiting10StepProps {
    step: Pregunta;
    handleSurveySteps: SurveyStepsHandler;
    iStep: number;
    finalStep: boolean;
    handleNext: () => void;
}

const getColorByGrade = (grade: number): string => {
    if (grade <= 2) return '#ef4444';
    if (grade <= 4) return '#f97316';
    if (grade <= 6) return '#eab308';
    if (grade <= 8) return '#84cc16';
    return '#22c55e';
};

const Raiting10Step = ({ step, handleSurveySteps, iStep, handleNext, finalStep }: Raiting10StepProps) => {
    const isTouchDevice = getIsTouchDevice();
    const xs = useMediaQuery('(min-width: 500px)');

    return (
        <div className="flex w-full flex-col pr-1.5">
            <div
                className={`
                    ${isTouchDevice && xs ? 'flex justify-center' : ''}
                    ${isTouchDevice ? 'pb-10' : 'pb-2.5'}
                `}
            >
                <strong
                    className={`
                        ${isTouchDevice ? (xs ? 'text-[27px]' : 'text-xl') : 'text-lg'}
                        ${isTouchDevice ? 'text-center' : 'text-right'}
                    `}
                >
                    {step.cPregunta}
                </strong>
            </div>
            <div className={`flex flex-wrap justify-center ${isTouchDevice ? '' : 'pt-5'}`}>
                {RAITING_NUMBERS.map((item) => {
                    const isActive = item <= Number(step?.cValor);
                    return (
                        <div key={item} className="p-0.5">
                            <button
                                className={`
                                    flex cursor-pointer items-center justify-center rounded
                                    transition-all duration-200 ease-in-out
                                    ${isTouchDevice ? 'h-17.5 w-17.5' : 'h-12 w-12'}
                                    max-[700px]:h-12 max-[700px]:w-12
                                `}
                                style={{
                                    backgroundColor: isActive ? getColorByGrade(item) : 'rgb(224, 224, 224)',
                                    color: isActive ? 'white' : 'rgb(137, 137, 137)',
                                }}
                                onClick={() => {
                                    handleSurveySteps(iStep, 'cValor', String(item));
                                    if (!finalStep) {
                                        setTimeout(() => {
                                            handleNext();
                                        }, 150);
                                    }
                                }}
                            >
                                <strong className={`${isTouchDevice ? 'text-2xl' : 'text-base'} max-[700px]:text-base`}>
                                    {item}
                                </strong>
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Raiting10Step;
